import React from 'react';
import { ArrowUpRightIcon, GithubIcon } from 'lucide-react';
import { featuredProject as p } from '../data/projects';
import { StatusTag } from './StatusTag';
export function FeaturedProject() {
  return <article className="rounded-2xl border border-teal-dim bg-panel p-8 lg:p-12" data-id="element-24" data-mp="213y20frnn0sv">
      <div className="grid gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,340px)]" data-id="element-25" data-mp="254gsa5dwfysy">
        <div data-id="element-26" data-mp="2sub7gtloxzgd">
          <div className="flex flex-wrap items-center gap-3" data-id="element-27" data-mp="2suko3qkuiu9e">
            <span className="font-mono text-xs uppercase tracking-widest text-teal" data-id="element-28" data-mp="2ss87bgqtqpxx">
              Proyecto raíz
            </span>
            <StatusTag status={p.status} data-id="element-29" data-mp="2jtwi9j5lw07l" />
          </div>

          <h3 className="mt-5 font-mono text-3xl font-bold tracking-tight text-ink-hi sm:text-4xl" data-id="element-30" data-mp="2jtd2a7zinlw7">
            {p.name}
          </h3>
          <p className="mt-3 font-mono text-lg text-magenta" data-id="element-31" data-mp="18er2pekdm76k">“{p.tagline}”</p>

          <p className="mt-6 max-w-2xl text-[17px] leading-relaxed text-ink-mid" data-id="element-32" data-mp="18gu2urf8tgp0">{p.summary}</p>

          <div className="mt-8 border-l-2 border-teal-dim pl-5" data-id="element-33" data-mp="1dbhkq7fqrcum">
            <p className="font-mono text-[11px] uppercase tracking-widest text-ink-mid" data-id="element-34" data-mp="h23jkc9taxz0">
              El concepto
            </p>
            <p className="mt-2 max-w-xl leading-relaxed text-ink-hi" data-id="element-35" data-mp="c4boxahs8xr4">{p.concept}</p>
          </div>

          <div className="mt-9 flex flex-wrap gap-3" data-id="element-36" data-mp="qxf1t4kfinbi">
            <a href={p.site} target="_blank" rel="noreferrer" className="group flex items-center gap-2 rounded-full bg-teal px-5 py-2.5 font-mono text-sm font-medium text-void transition-colors duration-150 ease-out hover:bg-ink-hi focus:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2 focus-visible:ring-offset-panel" data-id="element-37" data-mp="lzdfmarpi7vt">
              Visitar Labs
              <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:-translate-y-0.5" aria-hidden="true" data-id="element-38" data-mp="1iqnr62thaa4g" />
            </a>
            <a href={p.repo} target="_blank" rel="noreferrer" className="flex items-center gap-2 rounded-full border border-hairline px-5 py-2.5 font-mono text-sm text-ink-hi transition-colors duration-150 ease-out hover:border-teal hover:text-teal focus:outline-none focus-visible:ring-2 focus-visible:ring-teal" data-id="element-39" data-mp="1lsacxasbnu1c">
              <GithubIcon className="h-4 w-4" aria-hidden="true" data-id="element-40" data-mp="20izviy844bf8" />
              Repositorio
            </a>
          </div>
        </div>

        <div className="lg:border-l lg:border-hairline lg:pl-10" data-id="element-41" data-mp="29h22rvifw0ay">
          <h4 className="font-mono text-[11px] uppercase tracking-widest text-ink-mid" data-id="element-42" data-mp="2egy6rur4zrqi">Qué hay hoy</h4>
          <ul className="mt-4 space-y-3" data-id="element-43" data-mp="2jg0zcfpxk5hl">
            {p.points.map(point => <li key={point} className="flex gap-3 text-[15px] leading-relaxed text-ink-mid" data-id="element-44" data-mp="2jdy9pwsowede">
                <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-teal" aria-hidden="true" data-id="element-45" data-mp="k4zz3x8h73wq" />
                {point}
              </li>)}
          </ul>

          <h4 className="mt-8 font-mono text-[11px] uppercase tracking-widest text-ink-mid" data-id="element-46" data-mp="32d2vmijkjh72">Stack</h4>
          <ul className="mt-3 flex flex-wrap gap-2" data-id="element-47" data-mp="2xkrn4rarin2w">
            {p.stack.map(s => <li key={s} className="rounded-md border border-hairline bg-panelalt px-2.5 py-1 font-mono text-xs text-ink-mid" data-id="element-48" data-mp="2tkr75280m3tq">
                {s}
              </li>)}
          </ul>
        </div>
      </div>
    </article>;
}